import { render, staticRenderFns } from "./CreatePdfArchiveModalWrapper.vue?vue&type=template&id=f91e63ac"
import script from "./CreatePdfArchiveModalWrapper.vue?vue&type=script&lang=ts"
export * from "./CreatePdfArchiveModalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91e63ac')) {
      api.createRecord('f91e63ac', component.options)
    } else {
      api.reload('f91e63ac', component.options)
    }
    module.hot.accept("./CreatePdfArchiveModalWrapper.vue?vue&type=template&id=f91e63ac", function () {
      api.rerender('f91e63ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-archive/CreatePdfArchiveModalWrapper.vue"
export default component.exports